<div class="elementCont" id="paragraph-{{indexofelement}}">
    <div class="form-group form-group-custom-for-element">
        <div id="paragraph-text-{{indexofelement}}" class="overflowWrapAnywhere inpText" #paragraphInp>
            
        </div>    
    </div>
</div>
